export default __webpack_public_path__ + "static/media/wafer-bg-left-flat.07aa1702.png";